import React from 'react';
import { ParticularsFeature } from '@meitu/saas-editor-ui/es/collapses/image-enhance-collapse/particulars/particulars';
import { editor } from '@/instance';
import { ImagePanelFeatureType } from '@/types';
import { ICardMenuProps } from '../../type';
import ListMenu from '../components/list-menu';
import { useCardMenuHelper, useEnhanceOperateHelper } from '../hooks/use-enhance-helper';

const ParticularsEnhance: React.FC<ICardMenuProps> = ({
    onToggle,
    onReset,
    onSlider,
    featureType,
    curType,
    setCurType,
    trackFunc,
}) => {
    const enhanceOperate = useEnhanceOperateHelper({
        onSlider(type: string) {
            // 滑块完成
            onSlider?.(featureType, type);
        },
        onReset() {
            // 重置
            onReset?.(featureType);
        },
    });

    const cardMenuOperate = useCardMenuHelper(featureType, setCurType, (isShow: boolean, e: React.MouseEvent) => {
        // 点击菜单回调
        onToggle?.(featureType, isShow, e);
    });

    return (
        <ListMenu isShow={curType === ImagePanelFeatureType.ADJUST_PARTICULARS} {...cardMenuOperate}>
            <ParticularsFeature editor={editor} {...enhanceOperate} trackFunc={trackFunc} />
        </ListMenu>
    );
};

export default React.memo(ParticularsEnhance);
